import React, { forwardRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentUserFullName } from '../../store/slices/auth/authSelectors'
import ArrowDownLineIcon from '@rsuite/icons/ArrowDownLine'
import ArrowUpLineIcon from '@rsuite/icons/ArrowUpLine'
import MenuIcon from '@rsuite/icons/Menu';
import { Dropdown, Stack, Grid, Row, Col, useMediaQuery } from 'rsuite'
import { logout, resetAuthState } from '../../store/slices/auth/authSlice'
import usePlaceNavigate from '../../hooks/usePlaceNavigate'
import { resetDashboardState } from '../../store/slices/dashboard/dashboardSlice'
import { resetApplyState } from '../../store/slices/apply/applySlice'
import { resetRenewState } from '../../store/slices/renew/renewSlice'
import { resetUpdateState } from '../../store/slices/update/updateSlice'
import { resetStepState } from '../../store/slices/flow/flowSlice'
import { resetLicenseViewState } from '../../store/slices/licenseView/licenseViewSlice'
import { resetTaxState } from '../../store/slices/tax/taxSlice'
import { terminateSession } from '../../store/slices/auth/authThunks'
import { clearPersistedState } from '../../common/tokenPersistence'
import { resetAdminUpdateState } from '../../store/slices/adminUpdate/adminUpdateSlice'

const CustomToggle = forwardRef(({ onClick, name, isOpen }, ref) => (
    <Grid fluid
        role="grid"
        ref={ref}
        // className="pv-24"
        onClick={(e) => {
            e.preventDefault()
            onClick(e)
        }}
        tabIndex={0}
        onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                onClick(e)
            }
        }}
    >
        <Row>
            <Col xs={24} mdHidden lgHidden xlHidden xxlHidden>
                <MenuIcon style={{ fontSize: '24px' }} />
            </Col>
            <Col xs={24} xsHidden smHidden>
                <Stack>
                    <Stack.Item>
                        <span className="text-bold">{name}</span>
                    </Stack.Item>
                    <Stack.Item>
                        {isOpen ? <ArrowUpLineIcon style={{ fontSize: '24px' }} /> : <ArrowDownLineIcon style={{ fontSize: '24px' }} />}
                    </Stack.Item>
                </Stack>
            </Col>
        </Row>
    </Grid>
))

const AccountDropdown = () => {
    const placeNavigate = usePlaceNavigate()
    const dispatch = useDispatch()
    const [isToggled, setIsToggled] = useState(false)
    const selectedUserFullName = useSelector(selectCurrentUserFullName)

    const handleToggle = (isOpen) => {
        setIsToggled(isOpen)
    }
    const onLogoutClicked = () => {
        dispatch(logout())
        dispatch(terminateSession());
        dispatch(resetDashboardState());
        dispatch(resetApplyState());
        dispatch(resetRenewState());
        dispatch(resetUpdateState());
        dispatch(resetStepState());
        dispatch(resetLicenseViewState());
        dispatch(resetTaxState());
        dispatch(resetAuthState());
        dispatch(resetAdminUpdateState());
        clearPersistedState();
        placeNavigate('/')
    }

    const onEditDetailsClicked = () => {
        placeNavigate('/account-update');
    }

    const [isSmallScreen] = useMediaQuery('(max-width: 768px)');

    return (
        <Dropdown
            trigger="click"
            onToggle={handleToggle}
            renderToggle={(props, ref) => (
                <CustomToggle
                    {...props}
                    ref={ref}
                    name={selectedUserFullName}
                    isOpen={isToggled}
                />
            )}
            placement="bottomEnd"
        >
            {
                isSmallScreen && (
                    <Dropdown.Item
                        disabled
                        style={{ textAlign: 'right' }}>
                        {selectedUserFullName}
                    </Dropdown.Item>
                )
            }

            <Dropdown.Item
                onClick={onEditDetailsClicked}
                style={{ textAlign: 'right' }}>
                Change my personal details
            </Dropdown.Item>
            <Dropdown.Item
                onClick={onLogoutClicked}
                style={{ textAlign: 'right' }}
            >
                Logout
            </Dropdown.Item>
        </Dropdown>
    )
}

export default AccountDropdown
